import styled from 'styled-components'

export const GifContainer = styled.img`
  width: 250px;
`
